import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Styles from "./ReceivedModal.module.css";
import {
  fetchActiveLedger,
  setActiveListingId,
} from "../../../../Redux/Slices/bankingSlice";
import { ReactComponent as BackIcon } from "../../../../assets/images/back-left.svg";
import { ReactComponent as LineIcon } from "../../../../assets/images/line.svg";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import AvailableListing from "../../../Banking/ListingContainer/AvailableListing/AvailableListing";
import HeightIcon from "@mui/icons-material/Height";
import FilterModal from "../../../Banking/FilterModal/FilterModal";

const ReceivedModal = ({ open, handleClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [filterOpen, setFilterOpen] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState(null);
  const [filteredCount, setFilteredCount] = useState(0);

  const urlId = searchParams.get("id");
  const listingId =
    location.state?.listingId || (urlId ? parseInt(urlId, 10) : null);

  const allListings = useSelector(
    (state) => state?.bankingSlice?.allListings || []
  );
  const currentListing = allListings.find(
    (listing) => listing.id === listingId
  );

  const listingName = location.state?.listingName || currentListing?.name || ``;

  const [currentSort, setCurrentSort] = useState(null);

  const handleSortClick = () => {
    let newSort;
    if (currentSort === null) {
      newSort = "asc";
    } else if (currentSort === "asc") {
      newSort = "desc";
    } else {
      newSort = null;
    }
    setCurrentSort(newSort);
  };

  const handleApplyFilters = (filterData) => {
    setAppliedFilters(filterData);
  };

  const handleCountChange = (count) => {
    setFilteredCount(count);
  };

  useEffect(() => {
    if (listingId) {
      dispatch(setActiveListingId(listingId));

      dispatch(
        fetchActiveLedger({
          currentPage: 0,
          size: 20,
          bankingListingId: listingId,
        })
      );
    }
  }, [dispatch, listingId]);

  useEffect(() => {
    if (listingId && open) {
     
      dispatch(setActiveListingId(listingId));
    }

    // Cleanup: Reset activeListingId when modal closes to prevent conflicts
    return () => {
      if (!open) {
    
        dispatch(setActiveListingId(null));
      }
    };
  }, [dispatch, listingId, open]);

  return (
    <>
      {filterOpen && (
        <FilterModal
          open={filterOpen}
          handleClose={() => setFilterOpen(false)}
          onApplyFilters={handleApplyFilters}
          currentFilters={appliedFilters}
        />
      )}
      <div className={Styles.requestReceivedContainer}>
        <div className={Styles.receivedMainContainer}>
          <div className={Styles.receivedTableHeaderSection}>
            <div className={Styles.receivedHeadingPart}>
              <div
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <div
                  className={Styles.receivedBackButton}
                  onClick={() => {
                    // Check if user came from banking ledger
                    if (location.state?.fromBankingLedger) {
                      navigate("/banking_ledger", {
                        state: {
                          activeTab: location.state?.activeTab,
                        },
                      });
                    } else {
                      navigate("/banking");
                    }
                  }}
                >
                  <BackIcon />
                  Back
                </div>
                <div className={Styles.receivedHeading}>
                  <span className={Styles.spanReceivedText}>{listingName}</span>
                </div>
              </div>
            </div>
            <div
              className={` display_flex_row_center ${Styles.availableListingSortFilter}`}
            >
              <div className={Styles.sortHead}>Sort:</div>
              <div className={Styles.sortButton} onClick={handleSortClick}>
                Expiry Date {currentSort === "asc" && "↑"}
                {currentSort === "desc" && "↓"}
                {currentSort === null && (
                  <HeightIcon
                    style={{ fontSize: 18, verticalAlign: "middle" }}
                  />
                )}
              </div>{" "}
              <span style={{ color: "#f1935c" }}>
                <LineIcon />
              </span>
              <div
                className={`display_flex_row_center ${Styles.filterButton}`}
                onClick={() => setFilterOpen(true)}
              >
                <span>Filter</span>
                <ExpandMoreIcon style={{ fontSize: "16px" }} />
              </div>
            </div>
          </div>
        </div>

        <div className={`scroll_bar_y ${Styles.activeTableSet}`}>
          <AvailableListing
            expirySortDir={currentSort}
            selfListings={allListings}
            activeFilter=""
            appliedFilters={appliedFilters}
            onCountChange={handleCountChange}
            hideViewProfile={true}
          />
        </div>
      </div>
    </>
  );
};

export default ReceivedModal;
